import React from 'react';
import './Adbanner.css';

function AdBanner({ position }) {
    return <div className={`ad-banner ad-${position}`}>Ad Space ({position})</div>;
}

export default AdBanner;
